import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { Badge, List } from 'antd';
import { faCommentAlt, faRss } from '@fortawesome/pro-light-svg-icons';
import PropTypes from 'prop-types';
import { Box, ShowIf, Text } from '../../../shared/components';

export default function CanalListItem({ canal, link, descripcion, esNotificacion = false, date }) {
  const {
    nombre, id, totalNoLeido, pending,
  } = canal;

  const icon = (esNotificacion) ? faRss : faCommentAlt;

  const realLink = link || `/talk/${id}/mostrar`;

  return (
    <List.Item style={{ borderBottomColor: '#1d586f' }}>
      <List.Item.Meta
        title={(
          <Box>
            <FontAwesomeIcon icon={icon} color="lightgrey" />
            <ShowIf condition={pending !== true}>
              <Link to={realLink}><Text pl="8" color="white">{nombre}</Text></Link>
            </ShowIf>
            <ShowIf condition={pending === true}>
              <Text pl="8" color="white">{nombre}</Text>
            </ShowIf>
          </Box>
        )}
        description={(
          <Text
            style={{
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              display: 'block',
              overflow: 'hidden',
              width: '320px',
            }}
            fontSize="12"
            color="lightgray"
          >
            {descripcion}
          </Text>
        )}
      />
      <Box>
        <Text fontSize="12" color="lightgray">{date}</Text>
        <Box pt="8" style={{ textAlign: 'center' }}>
          <ShowIf condition={totalNoLeido !== 0}>
            <Badge style={{ boxShadow:"0 0 0 transparent" }} count={totalNoLeido} />
          </ShowIf>
          <ShowIf condition={totalNoLeido === 0}>
            &nbsp;
          </ShowIf>
        </Box>
      </Box>
    </List.Item>
  );
}

CanalListItem.propTypes = {
  canal: PropTypes.shape({
    descripcion: PropTypes.string.isRequired,
    id: PropTypes.any.isRequired,
    nombre: PropTypes.string.isRequired,
    totalNoLeido: PropTypes.number.isRequired,
    tipo: PropTypes.string.isRequired,
  }).isRequired,
};
